import { useState } from 'react'

import { events } from '@frame/lib/events'

export function useEmitComplete() {
  const [hasEmitted, setHasEmitted] = useState(false)
  return () => {
    if (hasEmitted) {
      return
    }
    setHasEmitted(true)
    events.emit('complete')
  }
}
